var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "file-upload" } }, [
    _c("div", { class: "file-align-" + _vm.align }, [
      !_vm.editingFieldLabel
        ? _c("h3", { on: { click: _vm.focusFieldLabel } }, [
            _vm._v(_vm._s(_vm.displayFieldLabel)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.editingFieldLabel
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localFieldLabelFile,
                expression: "localFieldLabelFile",
              },
            ],
            ref: "fieldLabelInput",
            staticClass: "field-label-input",
            attrs: { type: "text", placeholder: "Dosya Yükle" },
            domProps: { value: _vm.localFieldLabelFile },
            on: {
              blur: _vm.stopEditingFieldLabel,
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.stopEditingFieldLabel.apply(null, arguments)
              },
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.localFieldLabelFile = $event.target.value
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "upload-container" }, [
          _c("input", {
            staticClass: "file-input",
            attrs: {
              type: "file",
              id: "file-input-" + _vm.fieldId,
              multiple: "",
            },
            on: { change: _vm.handleFileUpload },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "file-label",
              attrs: { for: "file-input-" + _vm.fieldId },
            },
            [
              _c("div", { staticClass: "upload-icon" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                    },
                  },
                  [
                    _c("path", {
                      attrs: { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" },
                    }),
                    _vm._v(" "),
                    _c("polyline", { attrs: { points: "7,10 12,15 17,10" } }),
                    _vm._v(" "),
                    _c("line", {
                      attrs: { x1: "12", y1: "15", x2: "12", y2: "3" },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "upload-text" }, [
                _c("p", { staticClass: "upload-title" }, [
                  _vm._v(_vm._s(_vm.altLabelOne || "Dosya seçiniz")),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "upload-subtitle" }, [
                  _vm._v(_vm._s(_vm.altLabelTwo || "Dosya seçiniz")),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.files.length > 0
        ? _c(
            "div",
            { staticClass: "file-list" },
            _vm._l(_vm.files, function (file, index) {
              return _c("div", { key: index, staticClass: "file-item" }, [
                _c("div", { staticClass: "file-preview-container" }, [
                  _c("img", {
                    staticClass: "file-preview",
                    attrs: { src: file.preview },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "file-info" }, [
                  _c("span", { staticClass: "file-name" }, [
                    _vm._v(_vm._s(file.name)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "file-size" }, [
                    _vm._v(
                      _vm._s(_vm.formatFileSize(file.raw && file.raw.size))
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "delete-button",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.removeFile(index)
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                        },
                      },
                      [
                        _c("path", { attrs: { d: "M3 6h18" } }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" },
                        }),
                      ]
                    ),
                  ]
                ),
              ])
            }),
            0
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }